import { render } from "./AchievementsComponent.vue?vue&type=template&id=0d746bc7"
import script from "./AchievementsComponent.vue?vue&type=script&lang=js"
export * from "./AchievementsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__